// Middle truncation (DESIGN_SPEC §10.5): the head shrinks with an ellipsis, the tail never does.
//   <MT value tail? className? />   tail: number of trailing characters kept (default 16), or "file" = the last path segment
//   Both spans are real text, so selecting/copying yields the full value; the title holds it too.
import { cx } from "./cx";

function tailLength(value: string, tail: number | "file" = 16): number {
  if (tail !== "file") return Math.min(value.length, Math.max(0, tail));
  const cut = Math.max(value.lastIndexOf("\\"), value.lastIndexOf("/"));
  return Math.min(value.length, Math.max(12, value.length - cut));
}

export function MT({ value, tail = 16, className }: { value: string; tail?: number | "file"; className?: string }) {
  const n = tailLength(value, tail);
  return (
    <span className={cx("mt", className)} title={value} translate="no">
      <span className="mt-h">{value.slice(0, value.length - n)}</span>
      <span className="mt-t">{value.slice(value.length - n)}</span>
    </span>
  );
}

